module.exports = __webpack_public_path__ + "img/android.e83e7917.svg";